import { CardContent, Box } from '@mui/material';
import { DollarSign } from 'react-feather';
import { MinimalCard } from 'components/styled';

import { Typography, LinearProgress, StatsIcon } from './styles';

function Earnings() {
  return (
    <Box
      sx={{
        position: 'relative',
      }}
    >
      <MinimalCard $hoverEffect={false} sx={{ mb: 6, pt: 2 }}>
        <CardContent>
          <Typography variant="h2" gutterBottom>
            <Box
              sx={{
                fontWeight: 'fontWeightRegular',
              }}
            >
              $ 2.405
            </Box>
          </Typography>
          <Typography variant="body2" gutterBottom sx={{ mt: 3, mb: 0 }}>
            Total Earnings
          </Typography>

          <StatsIcon>
            <DollarSign />
          </StatsIcon>
          <LinearProgress variant="determinate" value={75} color="secondary" sx={{ mt: 4 }} />
        </CardContent>
      </MinimalCard>
    </Box>
  );
}

export default Earnings;
